import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Dialog, Typography } from '@chilecompra/react-kit/components'
import { onCloseConfirmNewAffidavitDialog } from './RegisterWizard.actions'
import { DialogButtons, DialogContent, DialogIcon, DialogMessage } from './RegisterWizardAffidavitAlertDialog.styles'

/**
 * The ConfirmNewAffidavitDialog's container.
 */
const ConfirmNewAffidavitDialog = () => {
  const dispatch = useDispatch()
  const { open } = useSelector(state => state.registerWizard.confirmNewAffidavitDialogState)
  const handleClose = () => dispatch(onCloseConfirmNewAffidavitDialog())
  return (
    <Dialog maxWidth="600px" open={open} onClose={handleClose}>
      <DialogContent>
        <DialogIcon alt="Confirm sign affidavit" src="/assets/icons/icono_alerta_circulo.svg" />
        <DialogMessage>
          <Typography fontWeight="bold" variant="h4">
            Campos pendientes por completar
          </Typography>
          <Typography variant="body2" margin="24px">
            Para continuar al siguiente paso deberás completar y firmar la Declaración Jurada de Socios y Accionistas
          </Typography>
          <DialogButtons>
            <Button onClick={handleClose}>Aceptar</Button>
          </DialogButtons>
        </DialogMessage>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmNewAffidavitDialog
